module.exports = __webpack_public_path__ + "static/scale-model-of-modesto-california-8dc3ab8249453d518acec7436f1adf7f.png";